import React from "react";
import {Helmet} from "react-helmet-async";

interface SeoProps {
    title?: string;
    description?: string;
    // Optional canonical/OG image override.
    image?: string;
}

const SITE_NAME = "EMDRlink";
const DEFAULT_TITLE = "Program EMDR Online - EMDRlink";
const DEFAULT_DESCRIPTION =
    "EMDR Online dla terapeutów. Twórz sesje, zapraszaj pacjentów i prowadź stymulację bilateralną online. Pacjent dołącza przez indywidualny link — nic nie musi instalować.";

// Centralised, reusable SEO/meta for each page. Sets the document title,
// meta description and Open Graph tags via react-helmet-async. A page passes
// just its own title/description; sensible site-wide defaults are used
// otherwise.
const Seo: React.FC<SeoProps> = ({title, description, image}) => {
    const fullTitle = title ? `${title} - ${SITE_NAME}` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESCRIPTION;
    return (
        <Helmet>
            <html lang="pl" />
            <title>{fullTitle}</title>
            <meta name="description" content={desc} />
            <meta property="og:type" content="website" />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={desc} />
            {image && <meta property="og:image" content={image} />}
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={desc} />
        </Helmet>
    );
};

export default Seo;
